import React, { Component } from 'react';
import {FormGroup, FormControl, HelpBlock, ControlLabel} from 'react-bootstrap';


import { RouteListItem } from '../components/RouteListItem';

export class RouteListPanel extends Component {

    constructor(props) {
      super(props);
      this.state = {
        filterValue: ''
      }
    }

    onFilterChange = (e) => {
      this.setState({
        filterValue: e.target.value
      })
    }

    getFilteredRoutes = () => {
      return this.props.routesList.filter((route) => {
        return (route.from.name.toLowerCase().search(
            this.state.filterValue.toLowerCase()) !== -1) ||
            (route.to.name.toLowerCase().search(
                this.state.filterValue.toLowerCase()) !== -1);
      })
    }

    render() {
        return(
                <div className="route-container">
                <FormGroup controlId="formBasicText">

                  <FormControl
                    type="text"
                    value={this.state.filterValue}
                    placeholder="Filter routes..."
                    onChange={this.onFilterChange}
                  />
                  <FormControl.Feedback />
                </FormGroup>

                    <ul className="todo-list m-t small-list ui-sortable">
                    {this.getFilteredRoutes().map((route, index) => {
                        return (
                          <RouteListItem key={index} routeData={route} onRouteSelect={this.props.onRouteSelect}></RouteListItem>
                        );
                    })}

                    </ul>

                </div>

            );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/RouteListPanel.js